export default __webpack_public_path__ + "static/MineralSwimV2_Purifier-fb5a88b33259123b768d576e95d00e91.png";